import { APIResponse } from 'types/Request';
import { deleteCookie, getCookie, responseError } from 'helpers';
import config from 'config';
import { RematriculacionRequest } from 'types/Rematriculacion';

function revokeCredentials() {
  deleteCookie('accessToken');
  deleteCookie('sessionCookie');
  // eslint-disable-next-line no-restricted-globals
  return location.reload();
}

export async function getSolicitudRematriculacion(): Promise<RematriculacionRequest> {
  try {
    const url = new URL(`${ config.baseUrl }/rematriculacion`);

    type Response = APIResponse<RematriculacionRequest>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las solicitudes.');
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok' || !content.payload) {
      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las solicitudes.');
    }

    return content.payload;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las solicitudes.');
  }
}

export async function postRematriculacionRequest(
  data: Partial<RematriculacionRequest>,
  files: Record<string, File>,
): Promise<any | undefined> {
  try {
    const formData = new FormData();

    Object.entries(files).forEach(([name, value]) => {
      formData.append(name, value);
    });

    formData.append('metadata', JSON.stringify(data));

    const res = await fetch(`${ config.baseUrl }/rematriculacion`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: getCookie('accessToken'),
      },
      body: formData,
    });

    if (res.status === 400) return responseError();

    if (res.status === 401 && true) {
      return revokeCredentials();
    }

    return res.json();
  } catch (err) {
    console.error('ApiService', 'Error de conexión al hacer Post con archivos');
    console.info(data, files);
    console.info(err);
    throw err;
  }
}

export async function getRematriculacionAmount(): Promise<number | null> {
  try {
    const url = new URL(`${ config.baseUrl }/rematriculacion/payment-amount`);

    type Response = APIResponse<number>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return null;
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok') {
      if (content.code === 'CONNECTION_ERROR') {
        return null;
      }

      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las solicitudes.');
    }

    return content.payload ?? null;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las solicitudes.');
  }
}
